import React from 'react'
import { Button } from 'react-bootstrap'
import AnalyticsPdfPeriodDropdown from './AnalyticsPdfPeriodDropdown'
import AnalyticsPdfSourceDropdown from './AnalyticsPdfSourceDropdown'
import styles from './AnalyticsPdfNavigation.module.css'

const ANALYTICS_PDF_TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'pages', label: 'Page Details' },
  { key: 'links', label: 'Link Details' }
]

const AnalyticsPdfTabNavigation = ({
  activeTab,
  onTabChange,
  selectedPeriod,
  onPeriodChange,
  selectedSource,
  sources,
  onSourceChange
}) => (
  <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2 flex-column flex-md-row">
    <div className={styles.tabContainer}>
      {ANALYTICS_PDF_TABS.map((tab) => (
        <Button
          key={tab.key}
          variant={activeTab === tab.key ? 'primary' : 'outline-primary'}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
        </Button>
      ))}
    </div>

    <div className="d-flex gap-2">
      {sources.length > 0 && (
        <AnalyticsPdfSourceDropdown selectedSource={selectedSource} sources={sources} onSelect={onSourceChange} />
      )}

      <AnalyticsPdfPeriodDropdown selectedPeriod={selectedPeriod} onSelect={onPeriodChange} />
    </div>
  </div>
)

export default AnalyticsPdfTabNavigation
